import { defineNuxtRouteMiddleware } from "nuxt/app";
import { useUiStore } from "~/stores/ui/uistore";

// Track the last navigation signature and timestamp
let lastNavigationSignature = "";
let userCancelled = false;
let lastNavigationTime = 0;

export default defineNuxtRouteMiddleware((to, from) => {
  // Create a unique signature for this navigation attempt
  const navigationSignature = `${from.fullPath}->${to.fullPath}`;
  const now = Date.now();

  // If this is the exact same navigation within 200ms, skip it
  if (
    navigationSignature === lastNavigationSignature &&
    now - lastNavigationTime < 500
  ) {
    console.debug("skipping check");

    if (userCancelled) {
      console.debug("aborting navigation because user cancelled before");
      return abortNavigation();
    }

    // because the check is skipped after the user clicked cancel once, on second run the page is changed..
    return;
  }

  // Update our tracking variables
  lastNavigationSignature = navigationSignature;
  lastNavigationTime = now;
  userCancelled = false; // Reset decision for new navigation

  // Skip if we're not actually changing routes
  if (to.fullPath === from.fullPath) return;

  const isDirty = useUiStore().isFormDirty;
  if (isDirty) {
    const confirmLeave = window.confirm(
      "You have unsaved changes. Are you sure you want to leave?",
    );
    lastNavigationTime = Date.now();
    if (!confirmLeave) {
      userCancelled = true; // Mark that user cancelled
      // Reset signature so user can try again
      setTimeout(() => (lastNavigationSignature = ""), 500);
      console.info("aborting navigation");
      return abortNavigation();
    }
    useUiStore().isFormDirty = false;
  }
});
